import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {useData} from '../../context/DataContext';
import {useLang} from '../../context/LanguageContext';
import { FaArrowLeft } from 'react-icons/fa';
import {useAuth} from "../../context/AuthContext";
import DateUtils from "../../utils/dateUtils";
import Footer from "../../components/Footer";

const TennisPage = () => {
  const navigate = useNavigate();
  const { tennisGames } = useData();
  const { t, getBetTranslation } = useLang();
  const { hasPaid } = useAuth();

  const [dayFilter, setDayFilter] = useState('all');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!tennisGames) {
    return (
      <div className="bg-gray-100 min-h-screen flex flex-col items-center justify-center relative">
        <button
          onClick={() => navigate('/')}
          className="absolute top-5 left-5 px-4 py-2 bg-gray-300 rounded flex items-center space-x-2"
        >
          <FaArrowLeft />
          <span>{t('btn.back')}</span>
        </button>
        <div>Loading matches...</div>
      </div>
    );
  }

  const dayCodes = new Set();
  tennisGames.forEach((g) => {
    const code = DateUtils.getDayCode(g.day);
    if (code) dayCodes.add(code);
  });
  const uniqueDayCodes = Array.from(dayCodes).sort();

  const dayOptions = uniqueDayCodes.map((code) => {
    const label = DateUtils.getDayLabel(code);
    return { code, label };
  });

  const filteredGames = tennisGames.filter((game) => {
    if (dayFilter === 'all') return true;
    const code = DateUtils.getDayCode(game.day);
    return code === dayFilter;
  });

  return (
    <div className="bg-gray-100 min-h-screen p-5 relative">
      <button
        onClick={() => navigate('/')}
        className="px-4 py-2 bg-gray-300 rounded mb-5 absolute top-5 left-5 flex items-center space-x-2"
      >
        <FaArrowLeft />
        <span>{t('btn.back')}</span>
      </button>

      <h1 className="text-xl font-bold mb-4 text-center mt-16">
        {t('txt.tennisPredictions')}
      </h1>

      <div className="max-w-xs mx-auto mb-4">
        <label className="block mb-1 font-semibold text-sm text-gray-700">
          {t('txt.filterDays')}:
        </label>
        <select
          className="w-full border border-gray-300 rounded px-2 py-1"
          value={dayFilter}
          onChange={(e) => setDayFilter(e.target.value)}
        >
          <option value="all">{t('txt.selectDays')}</option>
          {dayOptions.map((opt) => (
            <option key={opt.code} value={opt.code}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      <div className="space-y-4 mt-8">
        {filteredGames.map((game) => {
          const translatedDay = DateUtils.formatDayOnly(game.day, t);

          const translatedMarketName = getBetTranslation(game.marketName);
          const translatedMarket = getBetTranslation(game.market);

          return (
            <div
              key={game.id}
              className="bg-white shadow rounded p-4 flex flex-col md:flex-row md:items-center justify-between"
            >
              <div className="flex items-center mb-2 md:mb-0">
                {game.flag && (
                  <img
                    src={game.flag}
                    alt="Flag"
                    className="w-6 h-6 mr-2"
                  />
                )}
                <span className="font-bold text-sm">{game.countryName}</span>
              </div>

              <div className="flex flex-col md:flex-row md:items-center md:space-x-4 mb-2 md:mb-0">
                <span className="text-sm">{translatedDay}</span>
                <span className="text-sm">{game.hour}</span>
              </div>

              <div className="flex-1 flex flex-col md:items-start mb-2 md:mb-0">
                <span className="font-semibold text-sm">
                  {game.team1} vs {game.team2}
                </span>
              </div>

              {hasPaid ? (
                <div className="flex flex-col md:items-end">
                  <span className="text-sm text-gray-700">
                    {translatedMarketName} ({translatedMarket})
                  </span>
                  <span className="text-lg font-bold text-green-600">
                    {game.odd}
                  </span>
                </div>
              ) : (
                <button
                  onClick={() => navigate('/account')}
                  className="px-3 py-1 bg-blue-500 text-white rounded text-sm"
                >
                    {t('btn.unlockPremium')}
                </button>
              )}
            </div>
          );
        })}

        {filteredGames.length === 0 && (
          <p className="text-center text-gray-500">
            No matches found for this day.
          </p>
        )}
      </div>
        <Footer />
    </div>
  );
};

export default TennisPage;
